import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-start px-6 py-32">
      <p
        className="font-mono text-[12px] uppercase"
        style={{ color: 'var(--color-accent-600)', letterSpacing: '0.10em' }}
      >
        404 / Not found
      </p>
      <h1
        className="mt-3"
        style={{
          fontSize: '2.25rem',
          fontWeight: 700,
          letterSpacing: '-0.032em',
        }}
      >
        We couldn&apos;t find that page.
      </h1>
      <p className="mt-3 text-[15px]" style={{ color: 'var(--fg-mid)' }}>
        The link may be out of date, or the page may have moved. Try the home page or
        get in touch.
      </p>
      <div className="mt-7 flex gap-3">
        <Link to="/" className="ed-btn-primary">
          Back home
        </Link>
        <Link to="/contact" className="ed-btn-outline">
          Contact us
        </Link>
      </div>
    </div>
  );
}
